export default __webpack_public_path__ + "static/media/Wood-Finishes.5cc3533f.jpg";